(function () {
    'use strict';

    (function ($) {
        const storedPraferance = $.cookie('wps_praferance');
        if (storedPraferance) {
            if (storedPraferance === 'women') {
                $('#gender-toggle').prop('checked', true);
            } else {
                $('#gender-toggle').prop('checked', false);
            }
        }
        // Handle the checkbox toggle
        $('#gender-toggle').change(function () {
            const isWomen = $(this).is(':checked');
            $.cookie('wps_praferance', isWomen ? 'women' : 'men', { expires: 365, path: '/' });
            
            if (isWomen) {
                // If Women is selected
                $('#social-tab-list-detail-men').hide(); // Hide Men's tab list
                $('#social-tab-list-detail-women').show(); // Show Women's tab list
                $('#men-content').removeClass('open'); // Hide Men's content
                $('#women-content').addClass('open'); // Show Women's content
                $('#women-instagram-content').html('<div class="elfsight-app-5978f131-d36f-4f8b-9ad4-08cb2b20cea7"></div>');
                // Activate the first Women's tab and its content
                $('.social-tab-list-women').removeClass('active'); // Remove active class from all Women's tabs
                $('.social-tab-list-women-content').removeClass('active'); // Remove active class from all Women's content
                $('#women-instagram').addClass('active'); // Activate the first tab
                $('#women-instagram-content').addClass('active'); // Show corresponding content
            } else {
                // If Men is selected
                $('#social-tab-list-detail-women').hide(); // Hide Women's tab list
                $('#social-tab-list-detail-men').show(); // Show Men's tab list
                $('#women-content').removeClass('open'); // Hide Women's content
                $('#men-content').addClass('open'); // Show Men's content

                // Activate the first Men's tab and its content
                $('.social-tab-list').removeClass('active'); // Remove active class from all Men's tabs
                $('.social-tab-list-content').removeClass('active'); // Remove active class from all Men's content
                $('#men-instagram').addClass('active'); // Activate the first tab
                $('#men-instagram-content').addClass('active'); // Show corresponding content
                $('#men-instagram-content').html('<div class="elfsight-app-505a635e-0c81-462a-8e6f-56e8917a9e4c"></div>');
            }
        }).trigger('change');
        // Logic for Men's tabs
        $('.social-tab-list').click(function () {
            if (!$(this).hasClass('active')) {
                const tabid = $(this).attr('id');
                $('.social-tab-list').removeClass('active');
                $(this).addClass('active');

                $('.social-tab-list-content').removeClass('active');
                $(`#${tabid}-content`).addClass('active');

                // Dynamically load content for specific tabs
                if (tabid === 'men-facebook') {
                    $('#men-facebook-content').html('<div class="elfsight-app-f976567b-ffa9-4b2e-aa90-4aa4bc854b4b"></div>');
                } else if (tabid === 'men-instagram') {
                    $('#men-instagram-content').html('<div class="elfsight-app-505a635e-0c81-462a-8e6f-56e8917a9e4c"></div>');
                } else if (tabid === 'men-tiktok') {
                    $('#men-tiktok-content').html('<div class="elfsight-app-e4232349-8d4f-445c-a03e-d6e4e866229b"></div>');
                }
            }
            return false;
        });

        // Logic for Women's tabs
        $('.social-tab-list-women').click(function () {
            if (!$(this).hasClass('active')) {
                const tabid = $(this).attr('id'); // Get the clicked tab ID

                // Remove active class from all tabs and content
                $('.social-tab-list-women').removeClass('active');
                $('.social-tab-list-women-content').removeClass('active');

                // Add active class to the clicked tab
                $(this).addClass('active');
                $(`#${tabid}-content`).addClass('active'); // Show corresponding content

                // Dynamically load content based on the clicked tab ID
                if (tabid === 'women-instagram') {
                    $('#women-instagram-content').html('<div class="elfsight-app-5978f131-d36f-4f8b-9ad4-08cb2b20cea7"></div>');
                } else if (tabid === 'women-facebook') {
                    $('#women-facebook-content').html('<div class="elfsight-app-f976567b-ffa9-4b2e-aa90-4aa4bc854b4b"></div>');
                } else if (tabid === 'women-tiktok') {
                    $('#women-tiktok-content').html('<div class="elfsight-app-e4232349-8d4f-445c-a03e-d6e4e866229b"></div>');
                }
            }
            return false;
        });

        // Initialize default state (Men's section active)
        // $('#gender-toggle').prop('checked', false).trigger('change');
    })(jQuery);
})();

